
import { useState, useEffect } from 'react';
import { Row, Col } from "antd";
import Pagination from '@material-ui/lab/Pagination';
import HoneymoonStoryListing from './honeymoonStoryListing';
import AddHoneymoonStory from './addHoneymoonStory';
import EditHoneymoonStory from './editHoneymoonStory';
import { useDispatch, useSelector } from 'react-redux';
import * as HoneymoonAction from "../../../../actions/honeymoonAction";
import { Spinner } from 'react-bootstrap';

const Index = () => {
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();
    const [isAdd, setIsAdd] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const storyList = useSelector((state) => state.honeymoon.honeymoonStoryList);
    const storyDetails = useSelector((state) => state.honeymoon?.honeymoonStoryDetails);
    const [searchVal,setSearchVal]=useState('')
    const isDataLoading = useSelector(
        (state) => state.holidayListing.isDataLoading
      );
    useEffect(() => {
        dispatch(HoneymoonAction.honeymoonStoryList());
    }, []);
console.log(storyList, "storyList")
    useEffect(() => {
        selectedId && dispatch(HoneymoonAction.honeymoonStoryDetails(selectedId));
    }, [selectedId]);

    useEffect(() => {
        storyList?.length && setSelectedId(storyList[0].id);//selectedId || 
        if (storyList?.length) {
            setSelectedId(storyList[0].id);
            setIsAdd(false)
        } else {
            setSelectedId(null);
            setIsAdd(true)
        }
    }, [storyList]);

    return (
        <div>
            <p className="title-holder">Honeymoon Stories</p>
            <div>
                <Row>
                    <Col style={{ paddingRight: '20px', marginRight: '-20px' }} className="gutter-row" xs={24} lg={8}>
                        <Row className="gutter-row">

                            <HoneymoonStoryListing
                                storyList={storyList}
                                setIsAdd={setIsAdd}
                                setSelectedId={setSelectedId}
                                selectedId={selectedId}
                                searchVal={searchVal}
                                setSearchVal={setSearchVal}
                            />
                        </Row>

                    </Col>
                    <Col className="gutter-row" xs={24} lg={16}>
                    {isDataLoading&&
              <div className="blured-backround">
                <p>
                  <Spinner animation="border" variant="primary" />
                </p>
              </div>
            }
                        {isAdd ? <AddHoneymoonStory setIsAdd={setIsAdd} /> : <EditHoneymoonStory storyDetails={storyDetails} setSearchVal={setSearchVal} storyDetailsId={selectedId} />}

                    </Col>
                </Row>
            </div>
        </div>
    ); 
}

export default Index;